/*
* LegalDocumentsActions.js
* Copyright (c) Harman International Industries, Incorporated, 2024 - 2025
* All rights reserved.
*/
import APIManager from '../../ApiManager/ApiManager';
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";
import {FETCH_LEGAL_DOCS_DETAILS_REQUEST, FETCH_LEGAL_DOCS_DETAILS_SUCCESS, FETCH_LEGAL_DOCS_DETAILS_FAILURE} from './LegalDocumentsTypes';

export const fetchLegalDocsDetailsRequest = () => {
    return {
      type: FETCH_LEGAL_DOCS_DETAILS_REQUEST,
    };
  };
  
  export const fetchLegalDocsDetailsSuccess = (legalDocsData) => {
    return {
      type: FETCH_LEGAL_DOCS_DETAILS_SUCCESS,
      payload: legalDocsData,
    };
  };
  
  export const fetchLegalDocsDetailsFailure = (error) => {
    return {
      type: FETCH_LEGAL_DOCS_DETAILS_FAILURE,
      payload: error,
    };
  };
  
  export const fetchLegalDocsDetails = () => {
    return async function (dispatch) {
      dispatch(fetchLegalDocsDetailsRequest());
      try {
        const data = await APIManager.getLegalDocuments();
        dispatch(fetchLegalDocsDetailsSuccess(data));
      } catch (error) {
        dispatch(fetchLegalDocsDetailsFailure(error));
        dispatch(commonError(error, FETCH_LEGAL_DOCS_DETAILS_FAILURE));
      }
    };
  };
  
  export const commonError=(error,errorType)=>{
    return({
      type:COMMON_ERROR,
      payload:{
        message:error.message,
        errorType:errorType
      }
    })
  }
  

